module.exports = __webpack_public_path__ + "img/EDDY_MITCHELL_15s.8b15caea.jpg";